// !!!! Begin hover fade items interaction
// ################################
if (window.innerWidth >= 992) {
    const fadeTriggers = document.querySelectorAll("[data-fade-trigger]");
    const fadeItems = document.querySelectorAll("[data-fade-item]");
  
    if (fadeItems[0].classList.contains("active") === false) {
      fadeItems[0].classList.add("active");
    }
  
    if (fadeTriggers[0].classList.contains("active") === false) {
      fadeTriggers[0].classList.add("active");
    }
  
    fadeTriggers.forEach((trigger, trigIndex) => {
      trigger.addEventListener("mouseenter", () => {
        fadeTriggers.forEach((trigger) => {
          trigger.classList.remove("active");
        });
        fadeItems.forEach((fadeItem, itemIndex) => {
          if (fadeItem.classList.contains("active")) {
            fadeItem.classList.remove("active");
          }
          if (trigIndex === itemIndex) {
            fadeItem.classList.add("active");
          }
        });
        trigger.classList.add("active");
      });
    });
  }
  // ################################
  // !!!! End hover fade items interaction
  
  // !!!! Begin workshop slider
  // ################################
  
  var swiper = new Swiper(".swiper.workshop", {
    freeMode: {
      enabled: true,
      momentumVelocityRatio: 0.9,
      momentumBounceRatio: 0.1,
      momentumRatio: 2.1
    },
    grabCursor: true,
    observeParents: true,
    observer: true,
    keyboard: { enabled: true },
    resistanceRatio: 1,
    threshold: 1,
    watchSlidesProgress: true
  });
  
  // ################################
  // !!!! End workshop slider